import { memo } from 'react';

import { usePrivateWorkspaceAgentAssetListContext } from '~/components/v2/components/workspace/workspace-agent-asset-list/PrivateWorkspaceAgentAssetListProvider';
import { WORKSPACE_AGENT_ASSET_LIST_LABEL } from '~/components/v2/components/workspace/workspace-agent-asset-list/workspaceAgentAssetListConstants';
import { useWorkspaceAgentAssetListViewStore } from '~/components/v2/store/features/workspace/useWorkspaceAgentAssetListViewStore';

/** Page heading: the title from the loaded artifact rows, or the page label while that is still settling. */
export const PrivateWorkspaceAgentAssetListTitle = memo(() => {
  const { artifactId } = usePrivateWorkspaceAgentAssetListContext();
  const storedTitle = useWorkspaceAgentAssetListViewStore((state) =>
    artifactId ? state.titlesByArtifactId[artifactId] : undefined,
  );

  return (
    <h1
      className="ui2026:min-w-0 ui2026:truncate px-2 ui2026:px-0 font-semibold ads:text-primary text-12 text-gray-11 ui2026:text-18 ui2026:text-gray-12"
      data-testid="WORKSPACE_AGENT_ASSET_LIST_TITLE"
    >
      {storedTitle ?? WORKSPACE_AGENT_ASSET_LIST_LABEL}
    </h1>
  );
});

PrivateWorkspaceAgentAssetListTitle.displayName = 'PrivateWorkspaceAgentAssetListTitle';
